import { useState } from "react";

const faqs = [
  {
    question: "Pourquoi ma fenêtre frotte-t-elle en bas ?",
    answer: "C'est le signe le plus typique d'un gond usé. Le vantail s'affaisse de quelques millimètres sous son propre poids, et le bas du cadre vient frotter contre le seuil ou le dormant. Parfois, c'est aussi un défaut d'alignement dû à un mouvement du bâti de la maison. Notre technicien diagnostique la cause exacte : gond usé, réglage défaillant, ou torsion du dormant. Dans la plupart des cas, un remplacement de gond combiné à un réglage de hauteur suffit à éliminer le frottement.",
  },
  {
    question: "Peut-on remonter un vantail qui s'est affaissé sans changer le gond ?",
    answer: "Si le gond est de type réglable avec un excentrique, nous pouvons remonter le vantail de 2 à 5 mm en réglant la butée. C'est une solution rapide et efficace si le gond n'est pas encore trop usé. Si le roulement est écrasé ou si l'axe est oxydé, le réglage ne tient pas et il faut remplacer le gond. Notre technicien teste la solidité du réglage et vous conseille la solution la plus durable.",
  },
  {
    question: "Quel est le délai pour remplacer un gond ou une paumelle ?",
    answer: "Un remplacement de gond simple prend entre 45 minutes et 1h30 selon la taille du vantail et l'accessibilité du mécanisme. Nous intervenons du lundi au samedi, avec des créneaux le matin et l'après-midi. Pour une fenêtre bloquée ou un vantail qui risque de se détacher, nous pouvons généralement intervenir sous 24h dans tout le Bas-Rhin, y compris Strasbourg, Schiltigheim, Haguenau et Illkirch.",
  },
  {
    question: "Le prix du remplacement de gond est-il inclus dans le devis gratuit ?",
    answer: "Oui, le diagnostic et le devis sont entièrement gratuits, et le déplacement dans tout le Bas-Rhin est aussi offert. Le prix du remplacement dépend du type de gond (standard, réglable, à roulement, pour baie coulissante) et du matériau de la fenêtre. La pièce neuve et la main-d'œuvre sont comprises dans le devis. Pas de surprise : vous connaissez le montant exact avant que nous commencions l'intervention.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            FAQ — <span className="font-serif italic">Gond et paumelle</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-rose-200 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-plum text-sm md:text-base pr-4">
                    {faq.question}
                  </span>
                  <div
                    className={`w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0 transition-transform ${
                      openIndex === i ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-plum" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}